module.exports = __webpack_public_path__ + "static/media/ear.ee65f9db.svg";